export const getImageFromAssetFolder = (filename, folder) => {
  if (folder) return process.env.PUBLIC_URL + `/assets/${folder}` + filename;
  return process.env.PUBLIC_URL + "/assets/images/" + filename;
};
